export default __webpack_public_path__ + "static/IBMPlexSans-Italic-Latin2-b729b57f022eb1d859fc1d0e05f17fb6.woff";